//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import dayjs from 'dayjs'
import { EthDate } from '@shared/conversions'

export function formatDate(d: EthDate): string {
  return dayjs(Number(d) * 1000).format('MMMM D, YYYY')
}

export function formatDateTime(d: EthDate): string {
  return dayjs(Number(d) * 1000).format('D/MM/YYYY, hh:mm:ss Z')
}
